export var ACCOUNT_CLOSED = "CLOSED";
export var ACCOUNT_AUTH_PROHIBITED = "AUTH_PROHIBITED";
export var WAIVED_INTEREST = "WAIVED_INTEREST";
export var INTRO_RATE_LOAN = "INTRO_RATE_LOAN";
// All Account conditions
export var ACCOUNT_CONDITION = {
    CLOSED_WITH_BALANCE: "CLOSED_WITH_BALANCE",
    OPEN: "OPEN",
    AUTH_PROHIBITED: "AUTH_PROHIBITED",
    UPGRADING: "UPGRADING",
    SHELL: "SHELL",
    OVERLIMIT: "OVERLIMIT",
    DELINQUENT: "DELINQUENT",
    CREDIT_BALANCE: "CREDIT_BALANCE",
    CLOSED: "CLOSED",
    CHARGED_OFF: "CHARGED_OFF",
    CREDIT_LINE_INCREASE_ELIGIBLE: "CREDIT_LINE_INCREASE_ELIGIBLE",
    PRE_DELIVERY: "PRE_DELIVERY",
    DORMANT: "DORMANT",
};
//# sourceMappingURL=conditions.js.map